import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";

interface LabelStripeProps {
  /**
   * Text content to display in the stripe
   */
  text: string;
  /**
   * Optional CSS classes for the container
   */
  className?: string;
  /**
   * Optional CSS classes for the text
   */
  textClassName?: string;
}

/**
 * A horizontal stripe component with highlighted background,
 * typically used to display promotional or attention-grabbing text.
 */
export const LabelStripe = ({ text, className, textClassName }: LabelStripeProps) => {
  return (
    <div
      className={cn(
        "bg-highlight-default flex min-h-16 w-full flex-col items-center justify-center",
        className,
      )}
    >
      <p className={cn(textVariants.headline, "h-9 text-black uppercase", textClassName)}>{text}</p>
    </div>
  );
};
